import { Link, useLocation, useParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useCanAccessWorkerDocuments } from "@/features/auth/use-platform-features";

export function WorkerDetailTabs() {
  const { workerId } = useParams();
  const location = useLocation();
  const basePath = `/workers/${workerId ?? ""}`;
  const isDocuments = location.pathname.endsWith("/documents");
  const canAccessWorkerDocuments = useCanAccessWorkerDocuments();

  if (!workerId) return null;

  const tabs = [
    { key: "overview", label: "Overview", suffix: "" },
    ...(canAccessWorkerDocuments
      ? [{ key: "documents", label: "Documents", suffix: "/documents" }]
      : []),
  ] as const;

  if (tabs.length <= 1) return null;

  return (
    <div className="flex gap-1 rounded-lg bg-bg-light p-1">
      {tabs.map((tab) => {
        const active = tab.key === "documents" ? isDocuments : !isDocuments;
        return (
          <Link
            key={tab.key}
            to={`${basePath}${tab.suffix}`}
            className={cn(
              "rounded-md px-3 py-1.5 text-sm font-semibold transition-colors",
              active ? "bg-navy-deep text-white" : "text-navy-deep hover:bg-white",
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
